import { render } from "./AppLogo.vue?vue&type=template&id=428f3aa5"
import script from "./AppLogo.vue?vue&type=script&lang=js"
export * from "./AppLogo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/valdisaglonietis/PhpstormProjects/news_site/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"AppLogo.vue"]])

export default __exports__